module.exports = __webpack_public_path__ + "img/80bf33c.jpg";